import React from 'react'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import swal from "sweetalert2";
import * as Icon from 'lucide-react'
import contactSvg from '../assets/svg/contact.svg'
import {contactusService } from '../services/contactService';
export default function ContactUs() {
  const validationSchema = Yup.object({
    first_name: Yup.string().required('First Name is required!'),
    last_name: Yup.string().required('Last name is required'),
    email: Yup.string().email('Invalid email address').required('Email is required'),
    phone: Yup.string().required('Phone is required'),
    business_name: Yup.string().required('Business name is required'),
    inquiry_reason: Yup.string().required('Subject is required'),
    message: Yup.string().required('Message is required'),
    // Add more validations for other fields as needed
  });
  const formik = useFormik({
    initialValues:{
      first_name:'',
      last_name:'',
      email:'',
      phone:'',
      business_name:'',
      inquiry_reason:'',
      message:'',

    },
    validationSchema: validationSchema, 
    onSubmit:async(values, { resetForm })=>{
      const result = await contactusService(values);
 

      const {status,message}=result

if(status){
  resetForm();
  swal.fire({
    title: "success",
    text: message,
    icon: "success",
  });
}else {
  swal.fire({
    title: "Opps",
    text:message,
    icon: "error",
  })
}

    }


    
  })
  return (
    <>
    <section id="contact" className=" relative bg-white/10">

 <div className='w-full h-full absolute z-[-3] '>
  <img src={contactSvg} alt="" className='w-full h-full object-cover opacity-20' />
 </div>
  <div />
  <div className="container  px-5 md:px-20 m-auto">
    <div className="flex flex-wrap items-center -mx-4">
      <div className="px-4 w-full lg:w-7/12 xl:w-8/12">
        <div className="ud-contact-content-wrapper">
          <div className="ud-contact-title mb-12 lg:mb-[150px]">
            <span className="text-dark font-semibold text-base mb-5">
              CONTACT US
            </span>
            <h2 className="text-[35px] font-semibold">
           
              Let’s talk about LMIA’s.<br/> We would love to hear from you!
            </h2>
          </div>
          <div className="flex flex-wrap justify-between mb-12 lg:mb-0">
            <div className="flex items-center max-w-full w-[330px] mb-8">
              <div className="text-[32px] text-primary mr-3">
              <Icon.Phone size={45}/>
              </div>
              <div>
                <h5 className="text-lg font-semibold mb-1 mt-1">Call Us</h5>
                <a href='tel:+17787757785' className="text-base text-black font-bold">
                +1 778 775 7785
                </a>
              </div>
            </div>
            <div className="flex items-center max-w-full w-[330px] mb-8">
              <div className="text-[32px] text-primary mr-3">
              <Icon.Mail size={45} />
              </div>
              <div>
                <h5 className="text-lg font-semibold mb-1 mt-1">Email Us</h5>
                <a href="mailto:info@watershedcorp.ca" className="text-base text-black font-bold"> info@watershedcorp.ca</a>
               
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="px-4 w-full lg:w-5/12 xl:w-4/12">
        <div
          className="
      
          shadow-lg
          rounded-lg
          bg-white
          py-10
          px-8
          mb-5
          md:p-[60px]
          lg:p-10
          2xl:p-[60px]
          sm:py-12 sm:px-10
          lg:py-12 lg:px-10
          wow
          fadeInUp
        "
          data-wow-delay=".2s
        "
        >
          <h3 className="font-semibold mb-8 text-2xl md:text-[26px]">
            Send us a Message
          </h3>
          <form  onSubmit={formik.handleSubmit}>
            <div className="mb-6">
              <label htmlFor="fullName" className="block text-xs text-dark" formik={formik}>
               First Name*
              </label>
              <input
                type="text"
                name="first_name" 
      onChange={formik.handleChange}
      onBlur={formik.handleBlur}
      value={formik.values.first_name}
                placeholder="Enter First Name"
                className="
                w-full
                border-0 border-b border-[#f1f1f1]
                focus:border-primary focus:outline-none
                py-4
              "
              />
               {formik.touched.first_name && formik.errors.first_name && (
          <div className="text-red-500 text-xs mt-1">{formik.errors.first_name}</div>
        )}
            </div>
            <div className="mb-6">
              <label htmlFor="lastname" className="block text-xs text-dark" formik={formik}>
                Last Name*
              </label>
              <input
                type="text"
                name="last_name" 
                id='lastname'
      onChange={formik.handleChange}
      onBlur={formik.handleBlur}
      value={formik.values.last_name}
                placeholder="Enter Last Name"
                className="
                w-full
                border-0 border-b border-[#f1f1f1]
                focus:border-primary focus:outline-none
                py-4
              "
              />
               {formik.touched.last_name && formik.errors.last_name && (
          <div className="text-red-500 text-xs mt-1">{formik.errors.last_name}</div>
        )}
            </div>
            <div className="mb-6">
              <label htmlFor="email" className="block text-xs text-dark" formik={formik}>
                Email*
              </label>
              <input
                type="email"
                name="email" 
                id='email'
      onChange={formik.handleChange}
      onBlur={formik.handleBlur}
      value={formik.values.email}
                placeholder="example@yourmail.com"
                className="
                w-full
                border-0 border-b border-[#f1f1f1]
                focus:border-primary focus:outline-none
                py-4
              "
              />
                 {formik.touched.email && formik.errors.email && (
          <div className="text-red-500 text-xs mt-1">{formik.errors.email}</div>
        )}
            </div>
            <div className="mb-6">
              <label htmlFor="business" className="block text-xs text-dark" formik={formik}>
                Business Name
              </label>
              <input
                type="text"
                name="business_name" 
                id='business'
      onChange={formik.handleChange}
      onBlur={formik.handleBlur}
      value={formik.values.business_name}
                placeholder="Business Name"
                className="
                w-full
                border-0 border-b border-[#f1f1f1]
                focus:border-primary focus:outline-none
                py-4
              "
              />
                {formik.touched.business_name && formik.errors.business_name && (
          <div className="text-red-500 text-xs mt-1">{formik.errors.business_name}</div>
        )}
            </div>
            <div className="mb-6">
              <label htmlFor="reason" className="block text-xs text-dark" formik={formik}>
              Subject
              </label>
              <input
                type="text"
                name="inquiry_reason" 
                id="reason"
      onChange={formik.handleChange}
      onBlur={formik.handleBlur}
      value={formik.values.inquiry_reason}
                placeholder="Short Description"
                className="
                w-full
                border-0 border-b border-[#f1f1f1]
                focus:border-primary focus:outline-none
                py-4
              "
              />
                    {formik.touched.inquiry_reason && formik.errors.inquiry_reason && (
          <div className="text-red-500 text-xs mt-1">{formik.errors.inquiry_reason}</div>
        )}
            </div> 
            <div className="mb-6">
              <label htmlFor="phone" className="block text-xs text-dark" formik={formik}>
             Phone Number
              </label>
              <input
                type="text"
                name="phone" 
                id="phone"
      onChange={formik.handleChange}
      onBlur={formik.handleBlur}
      value={formik.values.phone}
                placeholder="Enter Phone Number"
                className="
                w-full
                border-0 border-b border-[#f1f1f1]
                focus:border-primary focus:outline-none
                py-4
              "
              />
                   {formik.touched.phone && formik.errors.phone && (
          <div className="text-red-500 text-xs mt-1">{formik.errors.phone}</div>
        )}
            </div> 
          
            <div className="mb-6">
              <label htmlFor="message" className="block text-xs text-dark" formik={formik}>
                Message*
              </label>
              <textarea
               name="message" 
      onChange={formik.handleChange}
      onBlur={formik.handleBlur}
      value={formik.values.message}
                rows={1}
                placeholder="Type Your Message Here"
                className="
                w-full
                border-0 border-b border-[#f1f1f1]
                focus:border-primary focus:outline-none
                py-4
                resize-none
              "
                defaultValue={""}
              />
                   {formik.touched.message && formik.errors.message && (
          <div className="text-red-500 text-xs mt-1">{formik.errors.message}</div>
        )}
            </div>
         
            <div className="mb-0" >
              <button
                type="submit"
                className="
                inline-flex
                items-center
                justify-center
                py-4
                px-6
                rounded
                text-white
                bg-primary
                text-base
                font-medium
                hover:bg-dark
                transition
                duration-300
                ease-in-out
              "
              >
                 Send Message
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>

    </>
  )
}
